import { SearchParams } from '@/types'
import { RunDecoderDiagnosticTaskResponse } from '@/types/cisgenicTask'
import { RunDiagnostic, RunDecoderDiagnostic } from '@/types/diagnostic'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

export const diagnosticsApi = {
  getAll(searchParams: SearchParams = {}) {
    const url = '/api/diagnostic'
    return axiosClient.get(url + queryStringify(searchParams))
  },
  runDiagnostic(payload: RunDiagnostic) {
    const url = '/api/diagnostic'
    return axiosClient.post(url, payload)
  },

  stopDiagnostic(payload: RunDiagnostic) {
    const url = '/api/diagnostic/stop'
    return axiosClient.post(url, payload)
  },

  runDecoderDiagnostic(payload: RunDecoderDiagnostic) {
    const url = '/api/diagnostic/decoder'
    return axiosClient.post(url, payload)
  },

  runDecoderDiagnosticTask(payload: RunDecoderDiagnostic) {
    const url = '/api/Diagnostic/decoder/tasks'
    return axiosClient.post<RunDecoderDiagnosticTaskResponse>(url, payload)
  },
}

export default diagnosticsApi
